// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import { isMobile } from "../../Common/Appcommon";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAMdHWgT2Ikkb1DRdRhMpE-aEzdKAa_O0E",
  authDomain: "cratio-2-0.firebaseapp.com",
  projectId: "cratio-2-0",
  storageBucket: "cratio-2-0.appspot.com",
  messagingSenderId: "997479411336",
  appId: "1:997479411336:web:96e92da1a71888b114393d",
  measurementId: "G-KD86STB90F"
};
// Initialize Firebase
const firebaseApp = !isMobile() ? initializeApp(firebaseConfig) : null;
const messaging = !isMobile() ? getMessaging(firebaseApp) : null;
const vapidKey="BO0Jn3AtO2udAoPsm9-0Q832x9DFmK7-wKFOzqqdosjIXENCmypQFYI6ErXDUuD74Ice_Jfw2UlmZao6iBgzFXA";

export const subscribeNotification = (fncallback) => {
  let response = [];
    return getToken(messaging, {vapidKey: vapidKey}).then((currentToken) => {
      let issuccess = false;
      let token = "";
      let error = "";
      if (currentToken) {
        console.log('current token for client: ', currentToken);
        //fncallback(currentToken);
        issuccess = true;
        token = currentToken;
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        error = "No registration token available. Request permission to generate one.";
        console.log('No registration token available. Request permission to generate one.');
        // fncallback(false);
        // shows on the UI that permission is required 
      }
      response['issuccess'] = issuccess;
      response['token'] = token;
      response['error'] = error;
      fncallback(response);
    }).catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
      response['issuccess'] = false;
      response['token'] = "";
      response['error'] = err;
      fncallback(response);
      // catch error while creating client token
    });
  /*let response = [];

  // Check if the browser supports the Notification and PushManager APIs
  if ('Notification' in window && 'PushManager' in window) {
    // Check if the user has granted permission
    if (Notification.permission === 'granted') {
      // Permission has already been granted
      // You can now get the push notification token
      getPushNotificationToken(fncallback);
    } else if (Notification.permission !== 'denied') {
      // Request permission from the user
      Notification.requestPermission().then(function (permission) {
        if (permission === 'granted') {
          // Permission has been granted
          // You can now get the push notification token
          getPushNotificationToken(fncallback);
        } else {
          // Permission has been denied
          console.log('Notification permission denied by the user.');
          updateResponse(false, "", "Notification permission denied by the user.", fncallback);
        }
      });
    } else {
      // The user has previously denied permission
      console.log('Notification permission denied by the user.');
      updateResponse(false, "", "Notification permission denied by the user.", fncallback);
    }
  } else {
    // Browser does not support the Notification or PushManager APIs
    console.log('Browser does not support web notifications or push notifications.');
    updateResponse(false, "", "Browser does not support web notifications or push notifications.", fncallback);
  }*/
};

// Function to get the push notification token
function getPushNotificationToken(fncallback) {
  // Use the PushManager to get the push subscription
  navigator.serviceWorker.ready
    .then(function (registration) {
      return registration.pushManager.subscribe({ 
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
       });
    })
    .then(function (subscription) {
      // Subscription successful, you can now use the subscription information
      const token = subscription ? extractTokenFromEndpoint(subscription.endpoint) : null;
      console.log('Push notification token:', token);
      // Send the token to your server for further processing

      // Optionally, you can use the token in your application
      // For example, you can save it in a variable, send it to the server, etc.
      // handleToken(token);

      // Update the response and invoke the callback
      updateResponse(true, token, "", fncallback);
    })
    .catch(function (error) {
      console.error('Error while getting push notification token:', error);
      // Update the response and invoke the callback with an error
      updateResponse(false, "", error.message || "Error while getting push notification token.", fncallback);
    });
}

// Helper function to update the response and invoke the callback
function updateResponse(issuccess, token, error, fncallback) {
  let response = {
    issuccess: issuccess,
    token: token,
    error: error
  };
  fncallback(response);
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}
function extractTokenFromEndpoint(endpoint) {
  // This is a simplified example; you might need a more robust method depending on your server's expectations
  return endpoint.split('/').pop();
}